/**
 * TRUHAIR Custom Mega Menu
 * File: assets/truhair-mega-menu.js
 *
 * IMPORTANT:
 * This replaces the inline <script>...</script> currently at the bottom of
 * snippets/truhair-mega-menu.liquid.
 *
 * Do not edit header.js or mega-menu.js.
 */

(() => {
  const ROOT_SELECTOR = '[data-truhair-custom-megas]';
  const PANEL_SELECTOR = '[data-truhair-mega-menu]';
  const DESKTOP_HEADER_SELECTOR = '.m-header__desktop';
  const MENU_ITEM_SELECTOR = '.m-menu > .m-menu__item';

  const OPEN_CLASS = 'is-open';
  const ACTIVE_ITEM_CLASS = 'truhair-custom-mega-parent';
  const TRIGGER_CLASS = 'truhair-custom-mega-trigger';
  const HEADER_ACTIVE_CLASS = 'm-mega-active';
  const CUSTOM_HEADER_ACTIVE_CLASS = 'truhair-custom-mega-open';

  let closeTimer = null;
  let currentPanel = null;
  let currentItem = null;

  const normalize = (value) =>
    (value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  const clearCloseTimer = () => {
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
  };

  const isInside = (container, node) => {
    return !!(container && node && container.contains(node));
  };

  const initTruhairMegaMenu = () => {
    const root = document.querySelector(ROOT_SELECTOR);
    const header = document.querySelector('m-header');
    const desktopHeader = document.querySelector(DESKTOP_HEADER_SELECTOR);

    if (!root || !header || !desktopHeader) return;
    if (root.dataset.truhairV4Initialized === 'true') return;

    root.dataset.truhairV4Initialized = 'true';

    const panels = [...root.querySelectorAll(PANEL_SELECTOR)];
    const menuItems = [...desktopHeader.querySelectorAll(MENU_ITEM_SELECTOR)];

    const closeAll = () => {
      clearCloseTimer();

      panels.forEach((panel) => panel.classList.remove(OPEN_CLASS));
      menuItems.forEach((item) => item.classList.remove(ACTIVE_ITEM_CLASS));

      header.classList.remove(HEADER_ACTIVE_CLASS);
      header.classList.remove(CUSTOM_HEADER_ACTIVE_CLASS);

      currentPanel = null;
      currentItem = null;
    };

    const scheduleClose = (delay = 220) => {
      clearCloseTimer();
      closeTimer = window.setTimeout(closeAll, delay);
    };

    const openPanel = (panel, item) => {
      clearCloseTimer();

      panels.forEach((candidate) => {
        candidate.classList.toggle(OPEN_CLASS, candidate === panel);
      });

      menuItems.forEach((candidate) => {
        candidate.classList.toggle(ACTIVE_ITEM_CLASS, candidate === item);
      });

      header.classList.add(HEADER_ACTIVE_CLASS);
      header.classList.add(CUSTOM_HEADER_ACTIVE_CLASS);

      currentPanel = panel;
      currentItem = item;
    };

    const addNativeArrow = (item) => {
      const directLink = item.querySelector(':scope > a');
      if (!directLink || directLink.querySelector('.m-menu__arrow')) return;

      const arrow = document.createElement('span');
      arrow.className = 'm-menu__arrow';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.innerHTML = `
        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M207.029 381.476 12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"/>
        </svg>
      `;

      directLink.appendChild(arrow);
    };

    panels.forEach((panel) => {
      const targetText = normalize(panel.dataset.menuTrigger);
      if (!targetText) return;

      const item = menuItems.find((candidate) => {
        const directLink = candidate.querySelector(':scope > a');
        return normalize(directLink?.textContent) === targetText;
      });

      if (!item) return;

      item.classList.add(TRIGGER_CLASS);
      item.classList.add('m-menu__item--has-submenu');
      addNativeArrow(item);

      /*
       * Open as soon as the pointer reaches the menu item.
       */
      item.addEventListener('mouseenter', () => {
        openPanel(panel, item);
      });

      /*
       * Critical fix:
       * Leaving the Shop <li> does NOT close the dropdown when the pointer is
       * still somewhere inside the desktop header. That entire white area
       * beneath the word Shop is treated as a safe corridor.
       */
      item.addEventListener('mouseleave', (event) => {
        const next = event.relatedTarget;

        if (
          isInside(desktopHeader, next) ||
          isInside(panel, next) ||
          isInside(root, next)
        ) {
          clearCloseTimer();
          return;
        }

        scheduleClose();
      });

      item.addEventListener('focusin', () => {
        openPanel(panel, item);
      });

      item.addEventListener('focusout', (event) => {
        const next = event.relatedTarget;

        if (
          isInside(item, next) ||
          isInside(panel, next) ||
          isInside(desktopHeader, next)
        ) {
          return;
        }

        scheduleClose();
      });

      /*
       * Once the pointer reaches the mega menu, cancel any pending close.
       */
      panel.addEventListener('mouseenter', () => {
        clearCloseTimer();

        if (currentPanel !== panel) {
          openPanel(panel, item);
        }
      });

      panel.addEventListener('mouseleave', (event) => {
        const next = event.relatedTarget;

        if (
          isInside(desktopHeader, next) ||
          isInside(item, next) ||
          isInside(root, next)
        ) {
          clearCloseTimer();
          return;
        }

        scheduleClose();
      });

      panel.addEventListener('focusin', clearCloseTimer);

      panel.addEventListener('focusout', (event) => {
        const next = event.relatedTarget;

        if (
          isInside(panel, next) ||
          isInside(item, next) ||
          isInside(desktopHeader, next)
        ) {
          return;
        }

        scheduleClose();
      });
    });

    /*
     * The whole desktop header is a safe hover corridor while the custom
     * mega menu is open. We only close after the pointer actually leaves the
     * header + custom mega-menu region.
     */
    desktopHeader.addEventListener('mouseenter', () => {
      if (currentPanel) clearCloseTimer();
    });

    desktopHeader.addEventListener('mouseleave', (event) => {
      if (!currentPanel) return;

      const next = event.relatedTarget;

      if (
        isInside(currentPanel, next) ||
        isInside(root, next)
      ) {
        clearCloseTimer();
        return;
      }

      scheduleClose();
    });


    /*
     * Minimog's native SiteNav calls resetMegaMenu() after a first-level
     * menu-item mouseleave and removes .m-mega-active after ~80ms.
     *
     * The custom class above keeps the overlay visible regardless, and this
     * observer also restores Minimog's active class while our panel is open so
     * any other header styling that depends on .m-mega-active stays intact.
     */
    const headerClassObserver = new MutationObserver(() => {
      if (!currentPanel) return;

      if (!header.classList.contains(CUSTOM_HEADER_ACTIVE_CLASS)) {
        header.classList.add(CUSTOM_HEADER_ACTIVE_CLASS);
      }

      if (!header.classList.contains(HEADER_ACTIVE_CLASS)) {
        header.classList.add(HEADER_ACTIVE_CLASS);
      }
    });

    headerClassObserver.observe(header, {
      attributes: true,
      attributeFilter: ['class']
    });

    /*
     * Moving across another first-level nav item should close the custom panel,
     * unless that item is itself assigned to another TRUHAIR panel.
     */
    menuItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (!currentPanel || item === currentItem) return;

        if (!item.classList.contains(TRIGGER_CLASS)) {
          closeAll();
        }
      });
    });


    const overlay = header.querySelector('.m-header__overlay');

    if (overlay) {
      overlay.addEventListener('click', () => {
        if (currentPanel) closeAll();
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });

    document.addEventListener('pointerdown', (event) => {
      if (!currentPanel) return;

      if (
        !isInside(currentPanel, event.target) &&
        !isInside(currentItem, event.target)
      ) {
        closeAll();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth < 1024) {
        closeAll();
      }
    });
  };

  const boot = () => {
    initTruhairMegaMenu();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => {
    const root = document.querySelector(ROOT_SELECTOR);
    if (root) {
      delete root.dataset.truhairV4Initialized;
    }
    boot();
  });
})();
